import styled from 'styled-components';

const variantBorderColor = {
  error: '#be1622',
  warning: '#f0c040',
  info: '#dee2e6',
  mail: '#dee2e6',
};

const variantIconColor = {
  error: '#be1622',
  warning: '#f0a500',
  info: '#6c757d',
  mail: '#6c757d',
};

const variantLinkHoverColor = {
  error: '#8f0f17',
  warning: '#5a4000',
  info: '#343a40',
  mail: '#343a40',
};

export const LimitWarning = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 18px;
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid ${(p) => variantBorderColor[p.$variant] || variantBorderColor.info};
  border-radius: 8px;
  color: #000;
`;

export const LimitWarningIcon = styled.div`
  margin-bottom: 6px;
  align-self: center;
  color: ${(p) => variantIconColor[p.$variant] || variantIconColor.info};
`;

export const LimitWarningContent = styled.div`
  flex: 1;
`;

export const LimitWarningTitle = styled.p`
  margin: 0 0 4px;
  font-weight: bold;
  font-size: 14px;
`;

export const LimitWarningDescription = styled.div`
  margin: 0 0 0px;
  font-size: 13px;
  color: #6c757d;
`;

export const LimitWarningLink = styled.a`
  color: #000;
  font-weight: bold;
  text-decoration: underline;
  &:hover {
    color: ${(p) => variantLinkHoverColor[p.$variant] || variantLinkHoverColor.info};
  }
`;

export const LimitWarningButton = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;
